import React from 'react';

function Pagination({ currentPage, totalPages, onPageChange }) {


    const pageNumbersToShow = () => {
        const pageNumbers = [];

        // Always show the first page
        pageNumbers.push(1);

        // Show "..." if currentPage is greater than 5
        if (currentPage > 4) {
            pageNumbers.push("...");
        }

        // Show pages near the current page (previous 3, current, next 3)
        for (let i = Math.max(2, currentPage - 3); i <= Math.min(totalPages - 1, currentPage + 3); i++) {
            pageNumbers.push(i);
        }

        // Show "..." if the current page is far from the last page
        if (currentPage < totalPages - 4) {
            pageNumbers.push("...");
        }

        // Always show the last page
        pageNumbers.push(totalPages);

        return pageNumbers;
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };


    if (totalPages <= 1) {
        return null;
    }

    return (
        <nav className="flex items-end gap-x-4 mt-4">
            {/* Back Button */}
            <button
                type='button'
                className="text-btn-color hover:text-btn-hover-color p-4"
                onClick={handlePrevious}
                disabled={currentPage === 1}
            >

                Back
            </button>

            {/* Page Numbers */}
            {pageNumbersToShow().map((page, index) => (
                <button
                    type='button'
                    key={index}
                    className={`p-4 ${currentPage === page ? 'text-black bg-btn-color border border-btn-color rounded-lg' : 'text-white hover:text-white'}`}
                    onClick={() => typeof page === 'number' && onPageChange(page)} // Ignore "..." clicks
                    disabled={page === '...'}
                >
                    {page}
                </button>
            ))}

            {/* Next Button */}
            <button
                type='button'
                className="text-btn-color hover:text-btn-hover-color p-4"
                onClick={handleNext}
                disabled={currentPage === totalPages}
            >

                Next
            </button>
        </nav>
    );
}

export default Pagination;
